{
  "title": "Detect Magic",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level divination (ritual)",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "For the duration, you sense the presence of magic within 30 feet of you. If you sense magic in this way, you can use your action to see a faint aura around any visible creature or object in the area that bears magic, and you learn its school of magic, if any.",
    "The spell can penetrate most barriers, but is blocked by 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt."
  ],
  "spellLists": ["artificer", "bard", "cleric", "druid", "paladin", "ranger", "sorcerer", "wizard"]
}
